
<div *ngIf="isLoading">
  <app-busy [message]="message"></app-busy>
</div>

<div class="filter-container">
    <div class="filter">
      <label for="filter1">Gazette No. {{this.event_id}}</label>
      <select type="text" id="filter1" name="filter1" class="form-control" [(ngModel)]="selectedStatus" (change)="saveModifiedGazette()">
        <option value="" disabled selected>{{status}}</option>
        <option value="0">Undefined</option>
        <option value="1">Saved</option>
        <option value="11">Ready for Approval</option>
        <option value="13">Returned for editing</option>
        <option value="15">Submitted for Approved</option>
        <option value="21">Approved</option>
        <option value="23">Submitted for Quote</option>
        <option value="31">Quote Accepted</option>
        <option value="41">Gazetted</option>
      </select>
    </div>
    <div class="filter">
      <label for="filter2">Gazette Date</label>
      <input  id="filter2" type="date" name="filter2" class="form-control"  [(ngModel)]="date_scheduled" (change)="saveModifiedGazette()">
    </div>
    <div class="filter">
        <label for="filter1">Gazette Sent</label>
        <input  id="filter1" type="date" name="filter1" class="form-control"  [(ngModel)]="date_sent" (change)="saveModifiedGazette()">
      </div>

  </div>
  <div style="float:right !important;margin-top: -50px;">
    <button type="button" class="btn btn-primary btn-mail" data-toggle="modal" data-target="#sendEmailGaz" [disabled]="isAdvert == false">Mail Advert to GPW</button>
    <button type="button" class="btn btn-primary" (click)="selectApplication()">+ Add an application</button>
  </div>
<table class="table custom_table" cellspacing="0" width="100%" *ngIf="!isEdit">
    <thead>
        <tr>
            <th>Application Number</th>
            <th>Carrier</th>
            <th>Permit Type</th>
            <th>Submission</th>
            <th>Application Status</th>
            <th>Status Changed By</th>
            <th>Advert</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let a of apps">
            <td>{{a.application.ApplicationNumber}}</td>
            <td>{{a.application.carrier.name}}</td>
            <td>{{a.application.PermitType}}</td>
            <td>{{a.application.submission_date}}</td>
            <td>{{a.application.status}}</td>
            <td>{{a.user_created}}</td>
            <td >
                {{a.note_1}}
            </td>
            <td >
              <img
              src="../../../../../assets/newimg/delete-30@2x.png"
              title="Delete Account"
              (click)="delete(a.id)"
              style="cursor: pointer; width: 18px"
            />
          </td>
        </tr>
    </tbody>
</table>

<div *ngIf="isEdit">
<textarea class="form-control" style="min-width: 100%;min-height: 400px;" [(ngModel)]="note" ></textarea>
</div>

            
<div class="float-right">
  <button type="button" class="btn btn-primary" routerLink="/list/gazettes" *ngIf="!isEdit">Back</button>
  <button type="button" class="btn btn-primary" *ngIf="!isEdit" [disabled]="apps.length == 0">Send for Approval</button>
  <button type="button" class="btn btn-primary" (click)="processAdvert()" *ngIf="!isEdit" [disabled]="apps.length == 0">Create Advert</button>
  <button type="button" class="btn btn-primary" (click)="clickEdit()" *ngIf="!isEdit" [disabled]="isAdvert == false">Edit Advert</button>
  <button type="button" class="btn btn-primary" (click)="clickBack()" *ngIf="isEdit">Back</button>
  <button type="button" class="btn btn-primary" (click)="saveModified()" *ngIf="isEdit">Save</button>
  <button type="button" class="btn btn-primary" *ngIf="!isEdit" [disabled]="isAdvert == false" (click)="downloadFile()">View Advert</button>
</div>


<!-- Add Popup -->
  <!-- Modal -->
  <div class="modal fade" id="sendEmailGaz" tabindex="-1" role="dialog" aria-labelledby="sendEmailGaz" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sendEmailGaz">Mail advert to GPW</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closesendEmailGaz">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="Form" style="padding: 10px 15px;">

          <div class="row">
                 Email Address
                  <input class="form-control" formControlName="email" required  width="fit-content"/>
          </div>
          <br>
          <div class="row">
                 Message
                    <quill-editor [styles]="{height: '200px'}"  formControlName="description" [modules]="quillConfig" required></quill-editor>   
          </div>
          </form>
           
        </div>
        <div class="modal-footer">

               <button class="btn btn-sm g-cancel" data-dismiss="modal">
                Cancel
               </button>
               <button class="btn btn-sm btn-gazette" [disabled]="Form.invalid" (click)="send()">
                Send
               </button>
        </div>
      </div>
    </div>
  </div>
